import { render, staticRenderFns } from "./DdTextBoxPlaceHolderFree.vue?vue&type=template&id=33fe5147&scoped=true&"
import script from "./DdTextBoxPlaceHolderFree.vue?vue&type=script&lang=js&"
export * from "./DdTextBoxPlaceHolderFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fe5147",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
